module.exports = __webpack_public_path__ + "img/course_img3.2d9aa82c.png";